module.exports = __webpack_public_path__ + "img/spin_btn.18137660.png";